import { Typography } from "@mui/material";
import { Family } from "protogen/advisors_service_pb";
import FlexBox from "components/common/FlexBox";
import useIsMobile from "components/hooks/useIsMobile";
import { useNavigate } from "react-router-dom";
import {
  TaskInspiration,
  TaskInspirationCategory,
  TaskWishlistEntry,
} from "protogen/tasks_pb";
import { InspiredTaskList } from "components/tasks/TaskInspiration";
import useIsDesktop from "components/hooks/useIsDesktop";

interface Props {
  family: Family;
  flex: number;
  taskInspirations?: TaskInspiration[];
  taskInspirationCategories?: TaskInspirationCategory[];
  taskWishlistEntries?: TaskWishlistEntry[];
}

export default ({
  family,
  flex,
  taskInspirations = [],
  taskInspirationCategories = [],
  taskWishlistEntries = [],
}: Props) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();

  const commonTasks = taskInspirations.filter((task) => {
    const category = taskInspirationCategories.find(
      (cat) => cat.ref === task.categoryRef,
    );
    return category && category.title === "Popular" && task.status === "active";
  });

  const trendingTasks = taskInspirations.filter((task) => {
    const category = taskInspirationCategories.find(
      (cat) => cat.ref === task.categoryRef,
    );
    return (
      category && category.title === "Seasonal" && task.status === "active"
    );
  });

  const onTaskClick = (task: TaskInspiration) => {
    navigate("/tasks/add", {
      state: { inspiredTask: task, family: family },
    });
  };

  const onWishlistTaskClick = (wishlistEntry: TaskWishlistEntry) => {
    navigate("/tasks/add", {
      state: { taskWishlistEntry: wishlistEntry, family: family },
    });
  };

  const hasContent =
    taskWishlistEntries.length > 0 ||
    commonTasks.length > 0 ||
    trendingTasks.length > 0;

  if (!hasContent) {
    return null;
  }

  return (
    <FlexBox variant="contained" direction="column" sx={{ flex: flex }}>
      <Typography variant={isMobile ? "h3" : "h4"}>Task inspiration</Typography>

      {taskWishlistEntries.length > 0 && (
        <FlexBox direction="column" gap="8px" sx={{ marginBottom: "16px" }}>
          <InspiredTaskList
            title="From their wishlist"
            tasks={taskWishlistEntries.map(
              (entry) =>
                ({
                  ref: entry.ref,
                  title: entry.title,
                  categoryRef: "",
                  status: "active",
                }) as TaskInspiration,
            )}
            onTaskClick={(task) => {
              const wishlistEntry = taskWishlistEntries.find(
                (entry) => entry.ref === task.ref,
              );
              if (wishlistEntry) {
                onWishlistTaskClick(wishlistEntry);
              }
            }}
            style="normal"
          />
        </FlexBox>
      )}

      <FlexBox
        direction={isDesktop ? "row" : "column"}
        gap={isMobile ? "24px" : "16px"}
        alignItems="start"
      >
        {commonTasks.length > 0 && (
          <InspiredTaskList
            title="Popular Faye tasks"
            tasks={commonTasks}
            onTaskClick={onTaskClick}
            style="normal"
          />
        )}
        {isMobile && trendingTasks.length > 0 && (
          <InspiredTaskList
            title="Seasonal tasks"
            tasks={trendingTasks}
            onTaskClick={onTaskClick}
            style="normal"
          />
        )}
      </FlexBox>
    </FlexBox>
  );
};
